
import React from 'react';
import './HexBackground.css';

const HexBackground: React.FC = () => {
  const hexagons = [];
  const rows = 20;
  const cols = 15;

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols; col++) {
      const delay = (row * 0.1 + col * 0.05) % 5;
      const opacity = Math.random() * 0.03 + 0.01;
      hexagons.push(
        <div
          key={`${row}-${col}`}
          className="hex"
          style={{
            left: `${col * 80 + (row % 2) * 40}px`,
            top: `${row * 70}px`,
            animationDelay: `${delay}s`,
            opacity: opacity,
          }}
        >
          <svg viewBox="0 0 100 115" className="hex-svg">
            <polygon
              points="50 1 95 25 95 75 50 99 5 75 5 25"
              fill="none"
              stroke="#14F195"
              strokeWidth="1"
            />
          </svg>
        </div>
      );
    }
  }

  return <div className="hex-background">{hexagons}</div>;
};

export default HexBackground;
